import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/vercel/path0/apps/frontend/components/dataprovider/apollo-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/apps/frontend/components/dataprovider/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseProvider"] */ "/vercel/path0/apps/frontend/components/hooks/supabase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/apps/frontend/components/widgets/google-analytics.tsx");
